'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RichText = function RichText(el) {
  (0, _classCallCheck3.default)(this, RichText);

  /* Remove p tags that wrap around images */
  (0, _jquery2.default)('.art-Article_Content .rte-RichText > p:has(img)').each(function () {
    (0, _jquery2.default)(this).before((0, _jquery2.default)(this).find('img'));
    if (!_jquery2.default.trim(this.innerHTML).length) (0, _jquery2.default)(this).remove();
  });
};

exports.default = RichText;